import classNames from "classnames";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";
import { focusOnMount } from "utilities/reactUtils";

interface Props {
  selected: boolean
  value?: any
  onClick: (clickedValue?: any) => void
  textClassNames?: string
  autoFocus?: boolean
  group?: string
}

const SelectableDiv = (props: React.PropsWithChildren<Props>) => {
  const classes = classNames({
    "focusable hoverable flex padding margin-bottom-mini gray-100 s1_selectmenu_selected blue-bg white-text": props.selected,
    "focusable hoverable flex padding margin-bottom-mini gray-100 s1_selectmenu_item": !props.selected
  });

  const textClassNames = classNames("s1_selectedmenu_text", props.textClassNames);

  const onKeyPress: React.KeyboardEventHandler<HTMLDivElement> = e => {
    if (e.key === " ") {
      e.preventDefault();
      props.onClick(props.value);
    }
  };

  return <div
    {...VerticalKeyboardNavigationGroup(props.group)}
    ref={props.autoFocus ? focusOnMount : undefined}
    tabIndex={0}
    className={classes}
    onClick={() => { props.onClick(props.value); }}
    onKeyDown={onKeyPress}
  >
    <div className={textClassNames} style={{ whiteSpace: "nowrap" }}>
      {props.children}
    </div>
  </div>;
};

export default SelectableDiv;